import { useClientAccountOverview } from '@ukpostbox/client-data';
import { ContentLoader, Tooltip, useLayout, useTranslation } from '@ukpostbox/frontend-framework';

import { FormatLocaleDate, FormatLocaleRelativeStrict } from '@ukpostbox/helpers';
import React from 'react';
import { NavLink } from 'react-router';
import { useSite } from '../../_Global/Providers/SiteInterfaceProvider';
import { EndpointError } from '../../_Global/Components/EndpointError';
import { AccountAllowanceEntry } from './AccountAllowanceEntry';

function AccountAllowance() {
	const { isMedium } = useLayout();
	const { currentLocale } = useSite();
	const { t } = useTranslation();

	const { data: userData, status: userStatus, error: userError } = useClientAccountOverview();

	return userStatus === 'error' ? (
		<EndpointError {...userError} />
	) : (
		<div className='user-account-allowance mb-xl'>
			<AccountAllowanceEntry
				title={t('accountAllowance.labels.mailAllowance')}
				figure={
					userStatus === 'pending' ? (
						<ContentLoader childCount={1} round childWidth={isMedium ? '10em' : '5em'} childHeight='2em' />
					) : (
						<span>{`${(
							userData.letterAllowance.remaining + userData.parcelAllowance.remaining
						).toLocaleString()}/${(
							userData.letterAllowance.total + userData.parcelAllowance.total
						).toLocaleString()}`}</span>
					)
				}
				footer={
					userStatus === 'pending'
						? ' '
						: `${t('accountAllowance.labels.resets')}: ${FormatLocaleDate(
								userData.allowanceResetDate,
								currentLocale,
							)}`
				}
			/>

			<AccountAllowanceEntry
				title={t('accountAllowance.labels.scanAllowance')}
				figure={
					userStatus === 'pending' ? (
						<ContentLoader childCount={1} round childWidth={isMedium ? '10em' : '5em'} childHeight='2em' />
					) : (
						<span>{`${userData.scanAllowance.remaining.toLocaleString()}/${userData.scanAllowance.total.toLocaleString()}`}</span>
					)
				}
				footer={
					userStatus === 'pending'
						? ' '
						: `${t('accountAllowance.labels.resets')}: ${FormatLocaleDate(
								userData.allowanceResetDate,
								currentLocale,
							)}`
				}
			/>

			<AccountAllowanceEntry
				title={t('accountAllowance.labels.renewal')}
				figure={
					userStatus === 'pending' ? (
						<ContentLoader childCount={1} round childWidth={isMedium ? '10em' : '5em'} childHeight='2em' />
					) : (
						<span>{FormatLocaleDate(userData.mailPlanRenewalDate, currentLocale)}</span>
					)
				}
				footer={
					userStatus === 'pending' ? (
						' '
					) : (
						<NavLink to='/manage-account/payment/renew'>{t('accountAllowance.actions.renew')}</NavLink>
					)
				}
			/>

			<AccountAllowanceEntry
				title={
					<>
						{t('accountAllowance.labels.primeStreetAddressInitials')}
						<Tooltip content={t('accountAllowance.labels.primeStreetAddress')} iconSize='1x' inText />{' '}
						{t('accountAllowance.labels.renewal')}
					</>
				}
				figure={
					userStatus === 'pending' ? (
						<ContentLoader childCount={1} round childWidth={isMedium ? '10em' : '5em'} childHeight='2em' />
					) : (
						<span>{FormatLocaleRelativeStrict(userData.addressPlanRenewalDate, currentLocale)}</span>
					)
				}
				footer={
					userStatus === 'pending' ? (
						' '
					) : (
						<NavLink to='/manage-account/payment/renew'>{t('accountAllowance.actions.renew')}</NavLink>
					)
				}
			/>
		</div>
	);
}

export { AccountAllowance };
